// extracted by mini-css-extract-plugin
module.exports = {"grayscale":"image_grayscale__GDQRy","c-image":"image_c-image__nLNoW","c-image-canvas":"image_c-image-canvas__hJmlR","c-image-parallax":"image_c-image-parallax__TrHrl"};